<template>
  <div class="app-loading" v-if="isLoading">
    <div class="hollow-dots-spinner">
      <div class="dot"></div>
      <div class="dot"></div>
      <div class="dot"></div>
    </div>
  </div>
</template>

<script setup>
import { computed } from 'vue';
import { useStore } from 'vuex';

// Vuex store
const store = useStore();

// Computed property
const isLoading = computed(() => store.state.user.isLoading);
</script>


<style lang="scss" scoped>
@import "~@ridmv/web-themes/styles/loading";
</style>
